import { defineStore } from "pinia";
import { useFetch } from "#app";

// @ts-ignore
export const useCdrStore = defineStore("CdrStore", {
  state: () => ({
    laoding: false,
    tableData: [],
    pages: 0,
    totalItems: 0,
    selectedAllFlag: false,
    hasActionItemsCount: 0,
    initialState: false,
    row: 1,
  }),
  getters: {},
  actions: {
    resetState() {
      this.tableData = [];
      this.pages = 0;
      this.selectedAllFlag = false;
      this.hasActionItemsCount = 0;
    },
    async getTotalPages(param: any, shouldReturnData: boolean) {
      const { data } = await useFetch<any>("/api/report/cdr/totalPages", {
        method: "POST",
        body: param,
        key: JSON.stringify(param),
      });
      if (shouldReturnData) return +data.value;
      this.totalItems = data.value;
      this.pages = parseInt(data.value) / 20;
      this.pages = Math.ceil(this.pages);
    },
    async getCdrs(param: any, shouldReturnData: boolean) {
      this.laoding = true;
      this.tableData = [];
      if (!shouldReturnData) this.laoding = true;

      try {
        const { data } = await useFetch<any>("/api/report/cdr/getCdr", {
          method: "POST",
          body: param,
        });
        const converted = await ConvertToClientModel(data.value);
        this.tableData = converted.map((item, i) => ({
          ...item,
          index: param.offset + i + 1,
        }));
        this.laoding = false;

        if (shouldReturnData) return this.tableData;
        const hastActionItems = this.tableData.filter((item: any) => {
          return item.hasAction;
        });
        this.hasActionItemsCount = hastActionItems.length;
        this.laoding = false;
      } catch (err) {
        if (shouldReturnData) return [];
        this.tableData = [];
      }
      this.laoding = false;
      this.initialState = true
    },
  },
});

import { useDateTimeManager } from "@/composable/useDateTimeManager";
import { useUsersOperatorStore } from "~/stores/users/operator";
import { useContactFormStore } from "@/stores/contact/form";

export const DetectCallDirection = (val: string) => {
  switch (val) {
    case "enterprise_out":
    case "nava_out":
      return {
        value: "خروجی",
        color: "#E3F8ED",
        textColor: "#4BD08B",
        border: "1px solid #A6E8C6",
      };
    case "enterprise_did":
      return {
        value: "ورودی",
        color: "#d4dfff",
        textColor: "#0085db",
        border: "1px solid #0085db",
      };
    case "internal":
      return {
        value: "داخلی",
        color: "#E3F8ED",
        textColor: "#4BD08B",
        border: "1px solid #A6E8C6",
      };
    case "divert":
      return {
        value: "دایورت",
        color: "#E3F8ED",
        textColor: "#4BD08B",
        border: "1px solid #A6E8C6",
      };
    default:
      return {
        value: "نا معلوم",
        color: "#E3F8ED",
        textColor: "#4BD08B",
        border: "1px solid #A6E8C6",
      };
  }
};

export const ConvertToClientModel = async (data: any) => {
  const cdrStore = useCdrStore();
  const contactFormStore = useContactFormStore();
  const { convertSec } = useDateTimeManager();
  const { dateToPersian } = useDateTimeManager();
  const usersOperatorStore = useUsersOperatorStore();

  const detectCustomForm = contactFormStore.formsList.find((item) => {
    return item.type == "custom";
  });

  const result: any = [];

  const allCallId = data.map((item: any) => {
    return item.id.toString();
  });

  const res = await $fetch("/api/contact/data/exists", {
    method: "POST",
    body: {
      form_type: detectCustomForm ? "custom" : "call_qa",
      field_name: "call_id",
      value_list: allCallId,
    },
  });

  data.forEach((element: any) => {
    let hasAction = false;

    // ** exist for cdr has action ** //
    if (
      element.rec_path &&
      !element.rec_path.startsWith("#") &&
      element.usge != 0
    ) {
      hasAction = true;
    }
    // ** exist for cdr has action ** //

    result.push({
      ...element,
      en_call_type: element.call_type,
      dateTime: new Date(element.setup_time),
      duration: element.usge / 1000000000,
      caller_number: element.caller,
      id: element.id,
      idView: element.id.slice(0, 6),
      caller: usersOperatorStore.getOperatorName(element.caller),
      destination: usersOperatorStore.getOperatorName(element.destination),
      oprator_number_qaqc:
        element.call_type == "nava_out" ? element.caller : element.destination,
      call_type: DetectCallDirection(element.call_type),
      usge: convertSec(element.usge / 1000000000),
      setup_time:
        `${element.setup_time.slice(11)}-` + dateToPersian(element.setup_time),
      cost: Math.ceil(Number(element.cost)) + " تومان",
      hasAction: hasAction,
      hasEvaluation: res[element.id] ? true : false,
      playState: false,
      selected: false,
      loading: false,
      row: cdrStore.row++,
    });
  });
  return result;
};
